// ProductHistoryDialog.js
import {
    defineComponent,
    ref,
    computed,
    watch,
    inject,
    nextTick,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
import HistoryCard from "../product/HistoryCard.js";
export default defineComponent({
    name: "ProductHistoryDialog",
    props: {},
    components: {
        HistoryCard,
    },
    emits: [],
    setup(props, { emit }) {
        const historyDialogPopup = inject("historyDialogPopup", ref(false));
        const groupShowType = inject("groupShowType");
        const titleRef = ref(null);
        const isVisible = ref(false);
        const isActive = ref(false);
        const modalContentRef = ref(null);
        const historyData = inject("historyData", ref([]));
        const historyBaseData = inject("historyBaseData", ref([]));

        const groupDates = computed(() => {
            if (
                !historyData.value ||
                !Array.isArray(historyData.value.groups)
            ) {
                return [];
            }

            return historyData.value.groups.map((group) => {
                const leaveDateParts = group.leaveDate.split("/");
                return {
                    leaveDate: leaveDateParts[1] + "/" + leaveDateParts[2],
                    type: `type${group.status}`,
                };
            });
        });
        const groupMinPrice = computed(() => {
            const groups = historyData.value?.groups;

            if (!Array.isArray(groups) || groups.length === 0) {
                return {
                    price: 0,
                    sitePrice: 0,
                };
            }

            return groups.reduce(
                (minGroup, currentGroup) => {
                    if (currentGroup.price < minGroup.price) {
                        return {
                            price: currentGroup.price,
                            sitePrice: currentGroup.sitePrice,
                        };
                    }
                    return minGroup;
                },
                {
                    price: groups[0].price,
                    sitePrice: groups[0].sitePrice,
                }
            );
        });
        const showMoreText = computed(() => {
            if (groupShowType.value !== "horizontal") return false;

            if (!titleRef.value || !datesListRef.value) return false;

            const titleWidth = titleRef.value.offsetWidth;
            const datesWidth = datesListRef.value.offsetWidth;

            return datesWidth > titleWidth * 0.8;
        });

        const showMoreIcon = computed(() => {
            const isSmallScreen = window.innerWidth <= 576;
            const dateCount = groupDates.value.length;
            if (groupShowType.value === "vertical") {
                return isSmallScreen ? dateCount > 2 : dateCount > 3;
            } else {
                return isSmallScreen ? dateCount > 3 : true;
            }
        });
        const clearAll = () => {
            localStorage.removeItem("viewedGroups");
            historyBaseData.value = [];
        };
        const handleOverlayClick = (e) => {
            // 如果點擊的是 modal 外部，就關閉
            if (modalContentRef.value && !modalContentRef.value.contains(e.target)) {
                historyDialogPopup.value = false;
            }
        };

        watch(
            () => historyDialogPopup.value,
            async (newVal) => {
                if (newVal) {
                    isVisible.value = true;
                    await nextTick();
                    setTimeout(() => {
                        isActive.value = true;
                    }, 2);
                } else {
                    isActive.value = false;
                    setTimeout(() => {
                        isVisible.value = false;
                    }, 400);
                }
            },
            { immediate: true }
        );
        return {
            historyDialogPopup,
            isVisible,
            isActive,
            historyData,
            groupDates,
            showMoreText,
            showMoreIcon,
            groupMinPrice,
            clearAll,
            modalContentRef,
            handleOverlayClick
        };
    },
    template: html`
        <div
            class="productHistory_dialog Com_PopupBg"
            :style="{ display: isVisible ? 'block' : 'none' }"
            :class="{ active: isActive }"
            @click="handleOverlayClick"
        >
            <div class="modal-content Com_halfPopup" ref="modalContentRef">
                <div class="modal_header">
                    <h1>查看紀錄</h1>
                    <button
                        class="close_btn"
                        @click="historyDialogPopup = false"
                    >
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.8 28L0 25.2L11.2 14L0 2.8L2.8 0L14 11.2L25.2 0L28 2.8L16.8 14L28 25.2L25.2 28L14 16.8L2.8 28Z"
                                fill="#8A8A8A"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div class="modal_body">
                    <div class="title">查看紀錄</div>
                    <div class="content scrollbarWidth">
                        <ul class="product_itemList">
                            <template v-for="(item, index) in historyData">
                                <history-card :item="item"></history-card>
                            </template>
                        </ul>
                    </div>
                    <div class="modal_footer">
                        <button class="allDelete_btn" @click="clearAll">
                            全部清除
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `,
    methods: {},
});
